import { Injectable } from '@angular/core';
import { EditArt } from '../_interfaces/EditArt';
import { Ticket } from '../_interfaces/ticket';

@Injectable({
  providedIn: 'root'
})
export class TransferService {

 private _value: any
 private _ticket: Ticket
 private _popoverItem: EditArt
 private _popoverItemList: {id: number, name: string}[] = []

  constructor() { }

  public setVALUE(value: any){
    this._value = value
  }

  public getVALUE(){
    return this._value
  }

  //Popover
  public setPopoverSetSelectedItem(item: EditArt){
    this._popoverItem = item
  }

  public getPopoverSelectedItem(): EditArt{
    return this._popoverItem
  }
  public clearPopover(): void{
    this._popoverItem = null
  }

  //Ticket
  public setTicket(ticket: Ticket){
    this._ticket = ticket
  }

  public get ticket(){
    return this._ticket
  }

}
